import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Course } from '../Models/course.model';
import { CourseService } from '../Services/course.service';

@Component({
  selector: 'app-course-details-wrapper',
  templateUrl: './course-details-wrapper.component.html',
  styleUrls: ['./course-details-wrapper.component.css']
})
export class CourseDetailsWrapperComponent implements OnInit {

  course: Course;

  additionalCourse: Course;

  constructor(
    private _route: ActivatedRoute,
    private _courseService: CourseService
  ) { }

  ngOnInit() {

     // scroll
     document.querySelector('#componentTop').scrollIntoView({ behavior: 'smooth', block: 'center' });
     
    this._route.data.subscribe(
    ({course}) => {
      console.log('course: ', course);
      this.course = course;
    });


    this._route.params.subscribe((params) => {
      if (params['id'] === '10') {
        this._getAdditionalCourse(11);
      } else if (params['id'] === '11') {
        this._getAdditionalCourse(10);
      } else {
        this.additionalCourse = undefined;
      }
    });
  }

  private _getAdditionalCourse(courseId: number) {
    this._courseService.getCourseDetails(courseId).subscribe((course) => {
      this.additionalCourse = course;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/course-details-wrapper/course-details-wrapper.component.ts